import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { parseQuerystring } from "../utility";

/** Treats every property of T as an optional string. */
type OptionallyStringified<T> = { [K in keyof T]?: string };

/** Wraps an object and treats it as an inevitable query parameter. */
interface RouteQueryProps<T> {
  query: T;
}

/** Parses the query string and provides it as props to a given component. */
export default function withQuery<TProps, TOut>(Component: React.ComponentType<React.PropsWithChildren<TProps & RouteQueryProps<TOut>>>, parse: (query: OptionallyStringified<TOut>) => TOut): React.ComponentClass {
  class WithQuery extends React.PureComponent<TProps & RouteComponentProps<unknown>> {
    public render() {
      const query: OptionallyStringified<TOut> = parseQuerystring(this.props.location.search) as { [K in keyof TOut]?: string };
      const out = parse(query);

      return <Component {...this.props} query={out} />;
    }
  }

  return withRouter(WithQuery);
}

export {
  RouteQueryProps,
};
